import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import { useSelector } from 'react-redux';
import Chips from './chips';
import { QUERY_BLACKLIST as BLACKLIST } from '../../constants';
import { useInternationalization } from '../../features/i18n';

const QueryChips = () => {
  const location = useLocation()
  const history = useHistory()
  const { translate } = useInternationalization()
  const queryStringFromStore = useSelector(state => state.search.queryString)
  const [query, setQuery] = React.useState({})
  const queryKeys = Object.keys(query)
  const keyFilter = key => BLACKLIST.includes(key) === false
  const filteredKeys = queryKeys.filter(keyFilter)
  const isRenderable = query && filteredKeys.length > 0

  useEffect(() => {
    setQuery(qs.parse(queryStringFromStore))
    // eslint-disable-next-line
  }, [queryStringFromStore])

  const handleClick = (data) => {
    const {key, id, value} = data

    // Override 'typeAudience' to 'audience' manually
    let finalKey = key
    if(key === 'typeAudience'){
      finalKey = 'audience'
    }

    // Remove selected query from current URL string
    const toRemove = `${finalKey}=${value ? value : id}`
    const encoded = encodeURI(toRemove)
    const currentQueries = queryStringFromStore
    const newQueries = currentQueries.replace(encoded, '')

    // Remove unnecessary '?' and '&' from query string
    const query = qs.parse(newQueries)
    const newQueryString = qs.stringify(query)

    history.push(location.pathname + "?" + newQueryString);
  }

  const handleClear = () => {
    const newParams = new URLSearchParams(location.search)

    for (let index = 0; index < queryKeys.length; index++) {
      const queryKey = queryKeys[index];
      if(!BLACKLIST.includes(queryKey)){
        newParams.delete(queryKey)
      }
    }

    const newSearch = newParams.toString()

    history.push(`${location.pathname}?${newSearch}`)
  }

  return <>
    {
      isRenderable && <>
      <div className="flex md:items-center mb-5 lg:mb-8 pl-5 lg:pl-0">
        <div className="filter-items-wrapper w-3/4 lg:w-auto order-2 lg:order-1 overflow-x-auto">
          <Chips query={query} handleClick={handleClick}/>
        </div>
        <div
          className="clear-filters-wrapper w-1/4 lg:w-auto order-1 lg:order-2 lg:ml-4 cursor-pointer flex-none"
          onClick={() => handleClear()}
        >
          <p className="opacity-50 lg:opacity-100 text-gray-444 underline text-xs mb-2">
            {translate('SEARCH', 'clear')}
          </p>
        </div>
      </div>
      </>
    }
  </>
}

export { QueryChips }
